var map = {
	"./methods/payment/3x-sans-frais.svg": 3735,
	"./methods/payment/4x-sans-frais.svg": 5524,
	"./methods/payment/cb.svg": 5305,
	"./methods/payment/maestro.svg": 5589,
	"./methods/payment/mastercard.svg": 3522,
	"./methods/payment/virement-bancaire.svg": 992,
	"./methods/payment/visa.svg": 2389,
	"./methods/shipping/fedex.svg": 262,
	"./methods/shipping/geodis.svg": 2273,
	"./methods/shipping/kuehne-nagel.svg": 4746,
	"./methods/shipping/ups.svg": 8090,
	"./mineral-logo-footer.svg": 8268,
	"./mineral-logo.svg": 9208,
	"./partners/kuehne-nagel-logo.svg": 8820
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(function(id) {
		return __webpack_require__.t(id, 1 | 16);
	});
}
function webpackAsyncContextResolve(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 3105;
module.exports = webpackAsyncContext;